export default __webpack_public_path__ + "static/media/ifm-logo.8d53bcff.svg";